import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiFooterComponent } from './ui-footer/ui-footer.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [UiFooterComponent],
  exports: [UiFooterComponent],
})
export class SharedPartnerWebUiFooterModule {}
